// TODO:区分コード管理.xlsx参考
/**
 * H0001	社員区分
 */
export const e社員区分 = {
  事務員: "10",
  事務員管理職: "15",
  運行部員: "20",
  運行部員管理職: "25",
  乗務員: "30",
  契約乗務員: "31",
  役員: "80",
  システム管理者: "90",
} as const

export type T社員区分名称 = keyof typeof e社員区分
export type T社員区分 = typeof e社員区分[T社員区分名称]
// H0002	性別区分
// H0003	血液型区分
// H0004	入社区分
export const e入社区分 = {
  _4月入社: "1",
  _10月入社: "2",
  付与対象外: "9",
} as const
export type T入社区分名称 = keyof typeof e入社区分
export type 入社区分 = typeof e入社区分[T入社区分名称]

// H0006	適性診断種類区分
